import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { MainState } from './state';

const defaultState: MainState = {
  isLoggedIn: null,
  isEditMode: false,
  token: '',
  logInError: '',
  userProfile: null,
  notifications: []
};

export const mainModule = {
  state: defaultState,
  mutations,
  actions,
  getters
};
